
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateDirectChatDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1)]),
})
;
}
      